import React, { forwardRef } from 'react';

import { VectorSplashIcon } from '~/domains/design-system/vectors/VectorSplashIcon';
import dt from '~/testing';

import type { BaseBadgeProps } from '../types';
import { BADGE_SIZES } from '../types';
import useStyles from '../BadgeBase.styles';

interface SplashBadgeProps extends BaseBadgeProps {
  showWhiteBorder?: boolean;
  style?: React.CSSProperties;
}

const SplashBadge = forwardRef<HTMLDivElement, SplashBadgeProps>(
  (
    {
      size = 'medium',
      width,
      height,
      backgroundColor = '#4BEBE2',
      iconColor = '#fff',
      className,
      dataTestId = dt.designSystem.badges.splashBadge,
      showWhiteBorder = false,
      style,
      ...props
    },
    ref
  ) => {
    const { classes, cx } = useStyles({
      size,
      width,
      height,
      backgroundColor,
    });

    const finalSize =
      width && height ? { size: width, iconHeight: height * 0.5 } : BADGE_SIZES[size];
    const iconHeight = finalSize.iconHeight;

    const badgeStyle = {
      ...style,
      ...(showWhiteBorder && {
        boxShadow: '0 0 0 2px white',
      }),
    };

    return (
      <div
        ref={ref}
        className={cx(classes.badge, className)}
        data-test-id={dataTestId}
        {...props}
        style={badgeStyle}
      >
        <div className={classes.iconContainer}>
          <VectorSplashIcon height={iconHeight} color={iconColor} />
        </div>
      </div>
    );
  }
);

SplashBadge.displayName = 'SplashBadge';

export default SplashBadge;
